import React, { useState, useEffect } from 'react'
import '../styles/Category.css'

const BASE_URL = 'https://api.admin.yourhood.ge'

function Category() {
  const [categories, setCategories] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  // Modal state
  const [modal, setModal] = useState(null) // null | 'add' | 'edit' | 'delete'
  const [selected, setSelected] = useState(null)

  // Form state
  const [formTitle, setFormTitle] = useState('')
  const [formSizes, setFormSizes] = useState('') // comma separated

  const token = localStorage.getItem('token')

  const authHeaders = {
    'Content-Type': 'application/json',
    'X-Language': 'ka',
    'Authorization': token
  }

  const fetchCategories = async () => {
    setIsLoading(true)
    setError('')
    try {
      const res = await fetch(`${BASE_URL}/api/Categories/categories`, {
        headers: { 'X-Language': 'ka', 'Authorization': token }
      })
      const data = await res.json()
      if (res.ok) setCategories(data)
      else setError('კატეგორიების ჩატვირთვა ვერ მოხერხდა')
    } catch {
      setError('კავშირის შეცდომა')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => { fetchCategories() }, [])

  const showSuccess = (msg) => {
    setSuccess(msg)
    setTimeout(() => setSuccess(''), 3000)
  }

  const openAdd = () => {
    setFormTitle('')
    setFormSizes('')
    setModal('add')
  }

  const openEdit = (cat) => {
    setSelected(cat)
    setFormTitle(cat.title)
    setFormSizes(cat.sizes.join(', '))
    setModal('edit')
  }

  const openDelete = (cat) => {
    setSelected(cat)
    setModal('delete')
  }

  const closeModal = () => {
    setModal(null)
    setSelected(null)
    setError('')
  }

  const parseSizes = () => formSizes.split(',').map(s => s.trim()).filter(Boolean)

  const handleAdd = async () => {
    if (!formTitle.trim()) { setError('გთხოვთ შეიყვანოთ სათაური'); return }
    setIsLoading(true)
    try {
      const res = await fetch(`${BASE_URL}/api/Categories/add-category`, {
        method: 'PUT',
        headers: authHeaders,
        body: JSON.stringify({
          sizes: parseSizes(),
          translations: [{ languageCode: 'ka', title: formTitle }]
        })
      })
      if (res.ok) {
        closeModal()
        showSuccess('კატეგორია წარმატებით დაემატა')
        fetchCategories()
      } else {
        setError('დამატება ვერ მოხერხდა')
      }
    } catch {
      setError('კავშირის შეცდომა')
    } finally {
      setIsLoading(false)
    }
  }

  const handleEdit = async () => {
    if (!formTitle.trim()) { setError('გთხოვთ შეიყვანოთ სათაური'); return }
    setIsLoading(true)
    try {
      const res = await fetch(`${BASE_URL}/api/Categories/edit-category`, {
        method: 'PUT',
        headers: authHeaders,
        body: JSON.stringify({
          categoryID: selected.id,
          sizes: parseSizes(),
          translations: [{ languageCode: 'ka', title: formTitle }]
        })
      })
      if (res.ok) {
        closeModal()
        showSuccess('კატეგორია წარმატებით განახლდა')
        fetchCategories()
      } else {
        setError('განახლება ვერ მოხერხდა')
      }
    } catch {
      setError('კავშირის შეცდომა')
    } finally {
      setIsLoading(false)
    }
  }

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      const res = await fetch(`${BASE_URL}/api/Categories/delete-category`, {
        method: 'DELETE',
        headers: authHeaders,
        body: JSON.stringify({ categoryID: selected.id })
      })
      if (res.ok) {
        closeModal()
        showSuccess('კატეგორია წარმატებით წაიშალა')
        fetchCategories()
      } else {
        setError('წაშლა ვერ მოხერხდა')
      }
    } catch {
      setError('კავშირის შეცდომა')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="cat-wrapper">

      <div className="cat-header">
        <div>
          <h2 className="cat-title">კატეგორიები</h2>
          <p className="cat-subtitle">{categories.length} ჩანაწერი</p>
        </div>
        <button className="cat-btn-add" onClick={openAdd}>+ დამატება</button>
      </div>

      {success && <div className="cat-success">{success}</div>}
      {error && !modal && <div className="cat-error">{error}</div>}

      {isLoading && !modal ? (
        <div className="cat-loading">იტვირთება...</div>
      ) : (
        <div className="cat-table-wrap">
          <table className="cat-table">
            <thead>
              <tr>
                <th>სათაური</th>
                <th>ზომები</th>
                <th>მოქმედება</th>
              </tr>
            </thead>
            <tbody>
              {categories.length === 0 ? (
                <tr><td colSpan={3} className="cat-empty">კატეგორიები არ მოიძებნა</td></tr>
              ) : (
                categories.map(cat => (
                  <tr key={cat.id}>
                    <td className="cat-td-title">{cat.title}</td>
                    <td>
                      <div className="cat-sizes">
                        {cat.sizes.map((s, i) => (
                          <span key={i} className="cat-size-tag">{s}</span>
                        ))}
                      </div>
                    </td>
                    <td>
                      <div className="cat-actions">
                        <button className="cat-btn-edit" onClick={() => openEdit(cat)}>რედაქტირება</button>
                        <button className="cat-btn-delete" onClick={() => openDelete(cat)}>წაშლა</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {modal && (
        <div className="cat-overlay" onClick={closeModal}>
          <div className="cat-modal" onClick={e => e.stopPropagation()}>

            {modal === 'delete' ? (
              <>
                <h3 className="cat-modal-title">კატეგორიის წაშლა</h3>
                <p className="cat-modal-text">
                  დარწმუნებული ხართ, რომ გსურთ <strong>{selected?.title}</strong> წაშლა?
                </p>
                {error && <div className="cat-error">{error}</div>}
                <div className="cat-modal-actions">
                  <button className="cat-btn-ghost" onClick={closeModal} disabled={isLoading}>გაუქმება</button>
                  <button className="cat-btn-danger" onClick={handleDelete} disabled={isLoading}>
                    {isLoading ? 'წაშლა...' : 'წაშლა'}
                  </button>
                </div>
              </>
            ) : (
              <>
                <h3 className="cat-modal-title">
                  {modal === 'add' ? 'ახალი კატეგორია' : 'კატეგორიის რედაქტირება'}
                </h3>

                <div className="cat-form-group">
                  <label className="cat-label">სათაური</label>
                  <input
                    className="cat-input"
                    placeholder="კატეგორიის სახელი"
                    value={formTitle}
                    onChange={e => setFormTitle(e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                <div className="cat-form-group">
                  <label className="cat-label">ზომები (მძიმით გამოყოფილი)</label>
                  <input
                    className="cat-input"
                    placeholder="S, M, L, XL"
                    value={formSizes}
                    onChange={e => setFormSizes(e.target.value)}
                    disabled={isLoading}
                  />
                </div>

                {error && <div className="cat-error">{error}</div>}

                <div className="cat-modal-actions">
                  <button className="cat-btn-ghost" onClick={closeModal} disabled={isLoading}>გაუქმება</button>
                  <button
                    className="cat-btn-primary"
                    onClick={modal === 'add' ? handleAdd : handleEdit}
                    disabled={isLoading}
                  >
                    {isLoading ? 'შენახვა...' : 'შენახვა'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

    </div>
  )
}

export default Category